const currencyCodes = {
	AED: 2, // UAE Dirham
	ALL: 2, // Albanian Lek
	AMD: 2, // Armenian Dram
	ANG: 2, // Antillian Guilder
	ARS: 2, // Argentine Peso
	AUD: 2, // Australian Dollar
	AWG: 2, // Aruban Guilder
	AZN: 2, // Azerbaijani manat
	BAM: 2, // Bosnia and Herzegovina Convertible Marks
	BBD: 2, // Barbados Dollar
	BDT: 2, // Bangladesh Taka
	BGL: 2, // Bulgaria Lev
	BGN: 2, // New Bulgarian Lev
	BHD: 3, // Bahraini Dinar
	BMD: 2, // Bermudian Dollar
	BND: 2, // Brunei Dollar
	BOB: 2, // Bolivia Boliviano
	BRL: 2, // Brazilian Real
	BSD: 2, // Bahamian Dollar
	BWP: 2, // Botswana Pula
	BYN: 2, // New Belarusian Ruble
	BZD: 2, // Belize Dollar
	CAD: 2, // Canadian Dollar
	CHF: 2, // Swiss Franc
	CLP: 2, // Chilean Peso
	CNY: 2, // Yuan Renminbi
	COP: 2, // Colombian Peso
	CRC: 2, // Costa Rican Colon
	CSD: 2, // Serbian Dinar
	CVE: 0, // Cape Verdi Escudo
	CZK: 2, // Czech Koruna
	DJF: 0, // Djibouti Franc
	DKK: 2, // Danish Krone
	DOP: 2, // Dominican Republic Peso
	DZD: 2, // Algerian Dinar
	LAK: 2, // Laos Kip
	LBP: 2, // Lebanese Pound
	LKR: 2, // Sri Lanka Rupee
	LTL: 2, // Lithuanian Litas
	LVL: 2, // Latvian Lats
	LYD: 3, // Libyan Dinar
	MAD: 2, // Moroccan Dirham
	MDL: 2, // Moldovia Leu
	MNT: 2, // Mongolia Tugrik
	MOP: 2, // Macau Pataca
	MRO: 1, // Mauritania Ouguiya
	MUR: 2, // Mauritius Rupee
	MVR: 2, // Maldives Rufiyaa
	MWK: 2, // Malawi Kwacha
	MXN: 2, // Mexican Peso
	MXP: 2, // Mexican Peso
	MYR: 2, // Malaysian Ringgit
	NAD: 2, // Namibian Dollar
	NGN: 2, // Nigerian Naira
	NIO: 2, // Nicaragua Cordoba Oro
	NOK: 2, // Norwegian Krone
	NPR: 2, // Nepalese Rupee
	NZD: 2, // New Zealand Dollar
	OMR: 3, // Rial Omani
	PAB: 2, // Panamanian Balboa
	PEN: 2, // Peruvian Nuevo Sol
	PGK: 2, // New Guinea Kina
	PHP: 2, // Philippine Peso
	PKR: 2, // Pakistan Rupee
	PLN: 2, // New Polish Zloty
	PYG: 0, // Paraguay Guarani
	QAR: 2, // Qatari Rial
	ROL: 2, // Romanian Lei
	RON: 2, // New Romanian Lei
	RSD: 2, // Serbian Dinar
	RUB: 2, // Russian Ruble
	EEK: 2, // Estonian Krone
	EGP: 2, // Egyptian Pound
	ETB: 2, // Ethiopian Birr
	EUR: 2, // Euro
	FJD: 2, // Fiji Dollar
	FKP: 2, // Falkland Islands Pound
	GBP: 2, // Pound Sterling
	GEL: 2, // Georgian Lari
	GHC: 0, // Ghanaian Cedi (2nd)
	GHS: 2, // Ghanaian Cedi (3rd)
	GIP: 2, // Gibraltar Pound
	GMD: 2, // Gambia Delasi
	GNF: 0, // Guinea Franc
	GTQ: 2, // Guatemala Quetzal
	GYD: 2, // Guyanese Dollar
	HKD: 2, // Hong Kong Dollar
	HNL: 2, // Honduras Lempira
	HRK: 2, // Croatia Kuna
	HTG: 2, // Haitian Gourde
	HUF: 2, // Hungarian Forint
	IDR: 0, // Indonesian Rupiah
	ILS: 2, // New Israeli Scheqel
	INR: 2, // Indian Rupee
	ISK: 2, // Iceland Krona
	JMD: 2, // Jamaican Dollar
	JOD: 3, // Jordanian Dinar
	JPY: 0, // Japanese Yen
	KES: 2, // Kenyan Shilling
	KGS: 2, // Kyrgyzstan Som
	KHR: 2, // Cambodia Riel
	KMF: 0, // Comoro Franc
	KRW: 0, // South-Korean Won
	KWD: 3, // Kuwaiti Dinar
	KYD: 2, // Cayman Islands Dollar
	KZT: 2, // Kazakhstani Tenge
	RWF: 0, // Rwanda Franc
	SAR: 2, // Saudi Riyal
	SBD: 2, // Solomon Island Dollar
	SCR: 2, // Seychelles Rupee
	SEK: 2, // Swedish Krone
	SGD: 2, // Singapore Dollar
	SHP: 2, // St. Helena Pound
	SKK: 2, // Slovak Koruna
	SLL: 2, // Sierra Leone
	SOS: 2, // Somalia Shilling
	STD: 2, // Sao Tome & Principe Dobra
	SVC: 2, // El Salvador Colón
	SZL: 2, // Swaziland Lilangeni
	THB: 2, // Thai Baht
	TND: 3, // Tunisian Dinar
	TOP: 2, // Tonga Pa'anga
	TRY: 2, // New Turkish Lira
	TTD: 2, // Trinidad & Tobago Dollar
	TWD: 2, // New Taiwan Dollar
	TZS: 2, // Tanzanian Shilling
	UAH: 2, // Ukraine Hryvnia
	UGX: 0, // Uganda Shilling
	USD: 2, // US Dollars
	UYU: 2, // Peso Uruguayo
	UZS: 2, // Uzbekistani Som
	VEF: 2, // Venezuelan Bolívar
	VND: 0, // Vietnamese New Dong
	VUV: 0, // Vanuatu Vatu
	WST: 2, // Samoan Tala
	XAF: 0, // CFA Franc BEAC
	XCD: 2, // East Carribean Dollar
	XOF: 0, // CFA Franc BCEAO
	XPF: 0, // CFP Franc
	YER: 2, // Yemeni Rial
	ZAR: 2, // South African Rand
	ZMW: 2, // Zambia Kwacha
};

/** A currency this module holds a minor-unit exponent for, and can therefore convert amounts of. */
export type CurrencyWithMinorUnits = keyof typeof currencyCodes;

/**
 * Whether amounts in `currency` can be converted to minor units.
 *
 * The ISO 4217 schemas accept codes this table does not list, and an amount in one of those cannot be sent
 * to a PSP at all — so callers that are about to charge should reject it rather than guess an exponent.
 */
export function hasMinorUnits(currency: string): currency is CurrencyWithMinorUnits {
	return currency in currencyCodes;
}

export function amountToMinorUnits(value: number, currency: CurrencyWithMinorUnits): number {
	// Rounded because float multiplication alone leaves dust — `19.99 * 100 === 1998.9999999999998` — and
	// a PSP is charged in WHOLE minor units, which is also what a payment token binds. Same convention as
	// `moneyAdd` in `apps/monolith/packages/money.ts`, which cannot be imported from here (the monolith
	// depends on this package, not the reverse).
	return Math.round(value * Math.pow(10, currencyCodes[currency]));
}
